/* istanbul ignore file */
// Add services to this type
export enum Services {
    ATVWebPresentationService = 'ATVWebPresentationService',
    ATVDiscoverService = 'ATVDiscoverService',
    PVStarlightPresentationServiceLambda = 'PVStarlightPresentationServiceLambda',
};

export type Endpoints = { [s in Services]: string };

// TODO: Extract inspector types into utils package
export interface Debug {
    operationName: string,
    serviceCalls: ServiceCalls
    logs: string[],
    startMillis: number,
    durationMillis: number,
    hostName: string,
    cacheLog: {
        hint: string;
        key: string;
        status: "Hit" | "Miss" | "None";
        value: string;
    }[]
};

export interface ServiceCalls {
    calls: any,
    meta: any,
};
